import { RevxButton } from 'components/RevxButton';
import { useTranslation } from 'react-i18next';
import './index.less';

export type FilesSubmitProps = {
  disabled: boolean;
  onClick: () => void;
  text: string;
};

const CommonFilesSubmit = (props: Partial<FilesSubmitProps>) => {
  const { disabled, onClick, text } = props;
  const { t } = useTranslation();
  return (
    <div className="common-files-submit">
      <RevxButton
        type="primary"
        disabled={disabled}
        onClick={() => {
          typeof onClick === 'function' && onClick();
        }}
      >
        {text || t('workspace.detail.files.submitForProof')}
      </RevxButton>
    </div>
  );
};

export default CommonFilesSubmit;
